import { IconTrash } from '@tabler/icons-react';
import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type IDeleteButtonProps = IBasicButtonProps;

const DefaultProps: Partial<IDeleteButtonProps> = {
  variant: 'filled',
  color: 'red.9',
  rightSection: <IconTrash />,
};

/** @registry Filled dark-red "Delete" button with a trash icon. */
export const DeleteButton = React.forwardRef<
  HTMLButtonElement,
  IDeleteButtonProps
>(({ children = 'Delete', ...props }, ref) => {
  return (
    <BasicButton {...DefaultProps} {...props} ref={ref}>
      {children}
    </BasicButton>
  );
});
DeleteButton.displayName = 'DeleteButton';
